import api from 'core/api/contentstack'
import { layoutData } from 'core/layout'
import Render from 'core/layout/Render'
import React from 'react'
import Head from 'next/head'

const WhereToBuy = (props: any) =>
  <>

    <Head>
      <meta name="ps-key" content={props.translations?.pricespider?.store_locator_api_key} />
      <meta name="ps-country" content={props.translations?.pricespider?.country} />
      <script src="//cdn.pricespider.com/1/lib/ps-widget.js" async></script>
      <script type="text/javascript" src="//cdn.pricespider.com/1/5039/ps-utid.js" async></script>
    </Head>

    <Render
      pageComponents={props.result?.shared_components?.components}
      contentTypeUid="page"
      translations={props.translations}
      entryUid={props.result?.uid}
      locale={props.result?.locale} />
    
  </>

export default WhereToBuy

export async function getStaticProps(context: any) {
  let result: any, layout: any
  try {
    ;[result, layout] = await Promise.all([
      api.getEntryByUrl("page", "/where-to-buy", context.locale, [
        "shared_components.components.featured_products.items",
        "shared_components.components.featured_products.items.color",
        "shared_components.components.featured_products.items.filters",
        "shared_components.components.featured_recipes.items",
        "shared_components.components.featured_recipes.items.filters",
        "shared_components.components.featured_recipes.items.product.color",
        "shared_components.components.featured_recipes.items.product.filters",
        "shared_components.components.mixed_content_banner.color",
        "shared_components.components.product_banner.product.color",
        "shared_components.components.product_banner.product",
        "shared_components.components.icon_sections.background_color",
        "shared_components.components.logo_showcase.background_color"
      ]),
      layoutData(api, context.locale),
    ])
  } catch (err) {
    console.error('getStaticProps (where-to-buy): fetch failed', err)
    return { notFound: true, revalidate: 60 }
  }

  // revalidate: 60 — retry aggressively while CMS entry is missing or unavailable
  if (!result) return { notFound: true, revalidate: 60 }

  return {
    props: { layout: true, ...layout, result, seo: result.seo },
    revalidate: 43200,
  }
}